import { Component, OnInit } from '@angular/core';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {FilterStorageService} from '../../services/filter-storage.service';
import {ProgressService} from '../../controls/progress.service';
import * as $ from 'jquery';
import {ActivatedRoute, Router} from '@angular/router';
import {OrganizationData} from '../../api/user-info-model';

@Component({
  selector: 'app-user-bulk-import',
  templateUrl: './user-bulk-import.component.html',
  styleUrls: ['./user-bulk-import.component.scss']
})
export class UserBulkImportComponent implements OnInit {

  public uploader: FileUploader;
  private organization: OrganizationData;

  constructor(private filters: FilterStorageService,
              private progress: ProgressService,
              private router: Router,
              private  route: ActivatedRoute) { }

  public hasBaseDropZoneOver = false;

  public fileOverBase(e: boolean): void {
    this.hasBaseDropZoneOver = e;
    console.log(e);
  }

  ngOnInit() {
    this.organization = this.filters.getSelectedOrganization();
    this.uploader = new FileUploader({url: `/api/organizations/${this.organization.id}/users/bulkinsert/1`});
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      return this.onSuccessItem(item, response, status, headers);
    };
    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      return this.onErrorItem(item, response, status, headers);
    };
  }

  fileSelected($event: File[]) {
    this.progress.show();
    this.uploader.uploadAll();
  }

  private onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
    this.progress.hide();
    alert('Successfully uploaded');
    this.router.navigate(['..'], {relativeTo: this.route});
  }

  private onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
    $('#reset-file-uploader').click();
    this.progress.hide();
    const messageResponse = JSON.parse(response);

    if (messageResponse.message != null) {
      alert(messageResponse.message);
      return;
    }
  }
}
